import { useEffect } from 'react';
import { Popover } from '@material-ui/core';
import Picker from '@emoji-mart/react';
import Utils from '@/common/utils/utils';
import { updateChatPostById } from '@/service/chatPostService';
import { getNewReactionByChatPost, validateReaction } from '../handler/MessageHandler';
import Constant from '@/common/constant/Constant';
import data from '@emoji-mart/data';

export const ReactionChatPost = ({ ...props }) => {
    const {
        userDetail,
        chatPost,
        chatPostAllList,
        reactionId,
        openReactionPopover,
        setReactionPopover,
        reactionPopoverId,
        reactionPopover,
        setReactionErrorMsg,
        setIsOpenReactionErrorDialog,
        setChatPostUpdate
    } = props;

    useEffect(() => {
        if (openReactionPopover && reactionPopoverId === chatPost?.id) {
            setTimeout(() => {
                let elemReaction = document.querySelector('#reaction-popover .MuiPopover-paper');
                let container = document.querySelector(
                    `#divChatContentList-${props.panelId}-${props.selectThread?.id}`
                );
                if (elemReaction && container) {
                    let elemReactions = elemReaction.getBoundingClientRect();
                    let containerChat = container.getBoundingClientRect();
                    if (elemReactions.right > containerChat.right) {
                        let widthNeedMove = elemReactions.right - containerChat.right + 30;
                        elemReaction.style.left = `${elemReactions.left - widthNeedMove - 80}px`;
                    }
                    if (elemReactions.left < containerChat.left) {
                        let widthNeedMove = containerChat.left - elemReactions.left + 30;
                        elemReaction.style.left = `${elemReactions.left - widthNeedMove - 80}px`;
                    }
                }
            }, 10);
        }
    }, [openReactionPopover, reactionPopoverId]);

    const onEmojiSelectHandler = emojiSelected => {
        setReactionPopover(null);

        let reactionMsg = chatPost.reaction ? Utils.convertJSONDataToObject(chatPost.reaction) : {};
        let messageError = validateReaction(reactionMsg, emojiSelected.id, userDetail.id);
        if (messageError !== '') {
            setReactionErrorMsg(messageError);
            setIsOpenReactionErrorDialog(true);
            return;
        }

        reactionMsg = getNewReactionByChatPost(reactionMsg, emojiSelected.id, userDetail.id);

        let index = chatPostAllList.findIndex((element, i) => {
            return element.id === chatPost.id;
        });

        let msgDetail = { ...chatPostAllList[index] };
        if (Utils.isEmptyObject(msgDetail)) {
            return;
        }
        msgDetail.subcriptionType = Constant.SUBSCRIPTION_TYPE.UPDATE;
        msgDetail.reaction = JSON.stringify(reactionMsg);
        setChatPostUpdate(msgDetail);

        const updateData = {
            id: chatPost.id,
            reaction: JSON.stringify(reactionMsg),
            updatedAt: chatPost.updatedAt,
        };
        updateChatPostById(props?.API, updateData).then(response => {
        });
    };

    return (
        <>
            <Popover
                id={reactionId}
                open={openReactionPopover && reactionPopoverId === chatPost?.id}
                anchorEl={reactionPopover}
                onClose={e => setReactionPopover(null)}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'left'
                }}
                transformOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left'
                }}
            >
                { reactionPopover &&
                <Picker
                    data={data}
                    theme={'light'}
                    skinTonePosition={'none'}
                    emojiButtonSize={38}
                    emojiSize={30}
                    maxFrequentRows={3}
                    onEmojiSelect={onEmojiSelectHandler}
                />}
            </Popover>
        </>
    );
};
